//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.GetSimpleListTemplateQuery
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object GetSimpleListTemplateQuery_ResponseAdapter {
  public object Data : Adapter<GetSimpleListTemplateQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("inspectionTemplates")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): GetSimpleListTemplateQuery.Data {
      var _inspectionTemplates: GetSimpleListTemplateQuery.InspectionTemplates? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _inspectionTemplates = InspectionTemplates.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return GetSimpleListTemplateQuery.Data(
        inspectionTemplates = _inspectionTemplates ?: missingField(reader, "inspectionTemplates")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: GetSimpleListTemplateQuery.Data,
    ) {
      writer.name("inspectionTemplates")
      InspectionTemplates.obj().toJson(writer, customScalarAdapters, value.inspectionTemplates)
    }
  }

  public object InspectionTemplates : Adapter<GetSimpleListTemplateQuery.InspectionTemplates> {
    public val RESPONSE_NAMES: List<String> = listOf("data")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): GetSimpleListTemplateQuery.InspectionTemplates {
      var _data: List<GetSimpleListTemplateQuery.Data1>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _data = Data1.obj().list().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return GetSimpleListTemplateQuery.InspectionTemplates(
        `data` = _data
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: GetSimpleListTemplateQuery.InspectionTemplates,
    ) {
      writer.name("data")
      Data1.obj().list().nullable().toJson(writer, customScalarAdapters, value.`data`)
    }
  }

  public object Data1 : Adapter<GetSimpleListTemplateQuery.Data1> {
    public val RESPONSE_NAMES: List<String> = listOf("id", "name")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): GetSimpleListTemplateQuery.Data1 {
      var _id: Any? = null
      var _name: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _name = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return GetSimpleListTemplateQuery.Data1(
        id = _id ?: missingField(reader, "id"),
        name = _name ?: missingField(reader, "name")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: GetSimpleListTemplateQuery.Data1,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("name")
      StringAdapter.toJson(writer, customScalarAdapters, value.name)
    }
  }
}
